import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en: {
      yes: "yes",
      no: "no",
      "are-you-sure": "are you sure?",
      seconds: "seconds",
    },
    es: {
      yes: "sí",
      no: "no",
      "are-you-sure": "estas seguro",
      seconds: "segundos",
    },
  },
});

export default i18n;
